/**
 * Linhas/cards de Peças em Sobra removidos manualmente.
 * Impede IndexedDB/localStorage/merge de ressuscitar o que o usuário apagou.
 */

export const CHAVE_SOBRA_EXCLUIDOS = 'sobra-pecas-excluidos-ade';

export function chaveLinhaSobra(entradaId: string, itemId: string): string {
  return `${String(entradaId || '').trim()}|${String(itemId || '').trim()}`;
}

export function lerExclusoesSobra(): {
  entradas: Set<string>;
  linhas: Set<string>;
} {
  try {
    const raw = localStorage.getItem(CHAVE_SOBRA_EXCLUIDOS);
    if (!raw) return { entradas: new Set(), linhas: new Set() };
    const parsed = JSON.parse(raw);
    const entradas = new Set(
      (Array.isArray(parsed?.entradas) ? parsed.entradas : [])
        .map((x: unknown) => String(x || '').trim())
        .filter(Boolean)
    );
    const linhas = new Set(
      (Array.isArray(parsed?.linhas) ? parsed.linhas : [])
        .map((x: unknown) => String(x || '').trim())
        .filter(Boolean)
    );
    return { entradas, linhas };
  } catch {
    return { entradas: new Set(), linhas: new Set() };
  }
}

function gravarExclusoes(entradas: Set<string>, linhas: Set<string>): void {
  try {
    localStorage.setItem(
      CHAVE_SOBRA_EXCLUIDOS,
      JSON.stringify({
        entradas: [...entradas].slice(-4000),
        linhas: [...linhas].slice(-8000),
      })
    );
  } catch {
    /* quota */
  }
}

export function registrarExclusaoEntradaSobra(entradaId: string): void {
  const id = String(entradaId || '').trim();
  if (!id) return;
  const { entradas, linhas } = lerExclusoesSobra();
  entradas.add(id);
  gravarExclusoes(entradas, linhas);
}

export function registrarExclusaoLinhaSobra(entradaId: string, itemId: string): void {
  const chave = chaveLinhaSobra(entradaId, itemId);
  if (chave === '|') return;
  const { entradas, linhas } = lerExclusoesSobra();
  linhas.add(chave);
  gravarExclusoes(entradas, linhas);
}

export function filtrarSobraNaoExcluidas<
  T extends { id?: string; itens?: Array<{ id?: string }> },
>(lista: T[]): T[] {
  const { entradas, linhas } = lerExclusoesSobra();
  if (entradas.size === 0 && linhas.size === 0) return lista;
  return lista
    .filter((e) => {
      const id = String(e.id || '').trim();
      return !(id && entradas.has(id));
    })
    .map((e) => {
      const entradaId = String(e.id || '').trim();
      const itens = Array.isArray(e.itens) ? e.itens : [];
      const filtrados = itens.filter((it) => {
        const itemId = String(it.id || '').trim();
        if (!itemId) return true;
        return !linhas.has(chaveLinhaSobra(entradaId, itemId));
      });
      if (filtrados.length === itens.length) return e;
      return { ...e, itens: filtrados };
    })
    .filter((e) => (Array.isArray(e.itens) ? e.itens.length : 0) > 0) as T[];
}
